import PropTypes from "prop-types";
import { CM_TOOLTIPS } from "./utils/tooltipsContent";

const getLegendItemKey = (item) => item.key ?? item.token ?? item.value ?? "";

const LegendDialog = ({
  open,
  onClose,
  title,
  items = [],
  sections = [],
}) => {
  if (!open) {
    return null;
  }

  const resolvedSections = sections.length > 0
    ? sections
    : [{ title, items }];

  return (
    <div className="cm-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="cm-dialog cm-legend-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cm-legend-dialog-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="cm-dialog-title" id="cm-legend-dialog-title">
          <button type="button" className="cm-dialog-close cm-btn" aria-label="Chiudi" title={CM_TOOLTIPS.chiudiLegenda} onClick={onClose}>
            ×
          </button>
        </div>

        <div className="cm-dialog-body cm-legend-body">
          {resolvedSections.map((section, sectionIndex) => (
            <section key={section.title || `legend-section-${sectionIndex}`} className="cm-legend-section">
              <p className="cm-legend-intro">
                <strong>{section.title}</strong>
              </p>
              <ul className="cm-legend-list">
                {(section.items || []).map((item) => {
                  const itemKey = getLegendItemKey(item);
                  return (
                    <li key={`${section.title}-${itemKey}`} className="cm-legend-item">
                      <code className="cm-legend-token">{itemKey}</code>
                      <span className="cm-legend-description">{item.description}</span>
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

LegendDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    token: PropTypes.string,
    value: PropTypes.string,
    description: PropTypes.string.isRequired,
  })),
  sections: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      token: PropTypes.string,
      value: PropTypes.string,
      description: PropTypes.string.isRequired,
    })),
  })),
};

export const CatalogLegendLink = ({ onClick, title = "Apri legenda" }) => (
  <button type="button" className="cm-legend-link" onClick={onClick} title={title}>
    [i]
  </button>
);

CatalogLegendLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default LegendDialog;
